import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../api";
import PageHero from "../components/PageHero";
import MarkdownView from "../components/MarkdownView";
import SEO from "../components/SEO";
import NotFound from "./NotFound";

export default function DynamicPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setLoading(true); setNotFound(false);
    api.get(`/pages/${slug}`)
      .then((r) => setPage(r.data))
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="py-32 text-center text-slate-400">Loading...</div>;
  if (notFound || !page) return <NotFound />;

  const seo = page.seo || {};
  return (
    <div>
      <SEO
        title={seo.title || page.title}
        description={seo.description}
        keywords={seo.keywords}
        ogImage={seo.ogImage}
        canonical={seo.canonical}
        noindex={seo.noindex}
        jsonLd={seo.jsonLd}
        type="article"
      />
      <PageHero title={page.title} breadcrumb={page.title} subtitle={seo.description} />
      <section className="section-pad">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="card-dark p-6 md:p-9">
            <MarkdownView>{page.body}</MarkdownView>
          </div>
        </div>
      </section>
    </div>
  );
}
